import React, { useEffect, useRef, useState } from "react";
import "./Card.css";
import { Card, CardActionArea } from "@mui/material";
import classNames from "classnames";
const CustomCard = ({ clicked, children, className }) => {
    // const [ripple, setRipple] = useState(false);

    // const handleClick = (event) => {
    //     const rect = event.target.getBoundingClientRect();
    //     const _rect = event.currentTarget;
    //     const size = Math.max(rect.width, rect.height);
    //     const x = event.clientX - rect.left - size / 2;
    //     const y = event.clientY - rect.top - size / 2;

    //     setRipple({
    //         visible: true,
    //         style: {
    //             width: size,
    //             height: size,
    //             top: y,
    //             left: x,
    //         },
    //     });

    //     // Reset ripple after animation duration (adjust as needed)
    //     setTimeout(() => {
    //         setRipple(false);
    //     }, 600);
    // };

    // const btnClass = classNames("button-with-ripple", className);

    return (
        <Card
            style={{ backgroundColor: "inherit" }}
            // className={btnClass}
            // onClick={(e) => {
            //     handleClick(e);
            //     clicked();
            // }}
            // onMouseDown={(e) => handleClick(e)}
        >
            <CardActionArea>{children}</CardActionArea>
            {/* {ripple && <span className="ripple" style={ripple.style}></span>} */}
        </Card>
    );
};

export default CustomCard;
